import React, { Component, Fragment } from "react";

import * as actions from "../../actions";
import { connect } from "react-redux";

import styled from "styled-components";

import DocumentMeta from "react-document-meta";
import ContentHeader from "../layout/ContentHeader";
import PanelWrapper from "../layout/PanelWrapper";
import LoadBarButton from "../LoadBarButton";
import Lightbox from "react-image-lightbox";

import Measure from "react-measure";

import Gallery from "react-photo-gallery";
import ServiceIcon from "../ServiceIcon";

class GalleryContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
      width: -1
    };
  }

  globalImageStore = [];

  componentDidMount() {
    if (!this.props.content.initialLoadComplete) {
      this.props.initialLoadGallery(this.props.content.offset);
    }
  }

  loadMoreImages() {
    if (!this.props.content.loading) {
      this.props.initialLoadGallery(this.props.content.offset);
    }
  }

  render() {
    const width = this.state.width;
    const { photoIndex, isOpen } = this.state;

    // let images = this.props.content.images.map(value => {
    //   return {
    //     src: value.acf.image.url,
    //     height: value.acf.image.height,
    //     width: value.acf.image.width
    //   };
    // });

    const meta = {
      title: "Gallery - Arthur Perfect Job",
      description:
        "Gallery of work carried out by Arthur Perfect Job. Plumbing, Demolition, Carpentry / Joinery, Electrics, Plastering / Rendering, Flooring, Drylining, Painting and Decorating, Suspended Ceilings, Handyman Service, Partition walls, Tiling.",
      meta: {
        charset: "utf-8",
        name: {
          keywords:
            "plumbing,demolition,carpentry,joinery,electrics,plastering,rendering,flooring,drylining,painting,decorating,suspended,ceilings,handyman,service,partition,walls,tiling.",
          "og:title": "Gallery - Arthur Perfect Job",
          "og:img": "https://apjhomerenovation.co.uk/img/opengraph.jpg",
          "og:type": "website"
        }
      }
    };

    // Store all images from all posts in a global array...
    this.globalImageStore = [];
    let internalKey = 1;
    this.props.content.images.map(post => {
      const postId = post.id;
      let internalId = 1;

      if (post.acf.image1) {
        const img = post.acf.image1;
        this.globalImageStore.push({
          src: img.url,
          height: img.height,
          width: img.width,
          postId: postId,
          id: internalId,
          key: internalKey
        });
        internalId++;
        internalKey++;
      }

      if (post.acf.image2) {
        const img = post.acf.image2;
        this.globalImageStore.push({
          src: img.url,
          height: img.height,
          width: img.width,
          postId: postId,
          id: internalId,
          key: internalKey
        });
        internalId++;
        internalKey++;
      }

      if (post.acf.image3) {
        const img = post.acf.image3;
        this.globalImageStore.push({
          src: img.url,
          height: img.height,
          width: img.width,
          postId: postId,
          id: internalId,
          key: internalKey
        });
        internalId++;
        internalKey++;
      }

      if (post.acf.image4) {
        const img = post.acf.image4;
        this.globalImageStore.push({
          src: img.url,
          height: img.height,
          width: img.width,
          postId: postId,
          id: internalId,
          key: internalKey
        });
        internalKey++;
      }
    });

    const galleryItems = this.props.content.images.map((item, key) => {
      let images = this.globalImageStore.filter(
        image => image.postId === item.id
      );

      return (
        <PanelWrapper key={key}>
          <Row>
            <Column>
              <GalleryTitle>{item.acf.title}</GalleryTitle>
              {item.acf.tags.map((i, key) => {
                const iconKey = (item.id + 1) * (key + 1);
                return <ServiceIcon key={iconKey} tag={i} />;
              })}
            </Column>
            <Column>
              <Images>
                {images.map((image, index) => {
                  return this.renderImageBlock(
                    image,
                    this.globalImageStore.findIndex(
                      i => i.postId === item.id && i.id === index + 1
                    )
                  );
                })}
              </Images>
            </Column>
          </Row>
        </PanelWrapper>
      );
    });

    return (
      <Fragment>
        <DocumentMeta {...meta} />
        <ContentHeader
          title="GALLERY"
          description="This page features a selection of photos of work carried out by Arthur Perfect Job"
        />

        {galleryItems}

        {isOpen && (
          <Lightbox
            mainSrc={this.globalImageStore[photoIndex].src}
            nextSrc={
              this.globalImageStore[
                (photoIndex + 1) % this.globalImageStore.length
              ].src
            }
            prevSrc={
              this.globalImageStore[
                (photoIndex + this.globalImageStore.length - 1) %
                  this.globalImageStore.length
              ].src
            }
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + this.globalImageStore.length - 1) %
                  this.globalImageStore.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % this.globalImageStore.length
              })
            }
          />
        )}

        {this.props.content.images.length < this.props.content.maxTotal ? (
          <PanelWrapper
            color={
              this.props.content.loading
                ? "rgba(0,0,0,0.85)"
                : "rgba(253,186,3,0.85)"
            }
            padding="0"
          >
            <LoadBarButton
              text="Load More Images"
              clickAction={this.loadMoreImages.bind(this)}
              loading={this.props.content.loading}
            />
          </PanelWrapper>
        ) : null}
      </Fragment>
    );
  }

  renderImageBlock(image, index) {
    return (
      <Image
        key={image.key}
        style={{
          backgroundImage: `url('${image.src}')`
        }}
        onClick={() => {
          this.setState({
            isOpen: true,
            photoIndex: index
          });
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  return { content: state.gallery };
}

export default connect(
  mapStateToProps,
  actions
)(GalleryContent);

const GalleryTitle = styled.h1`
  color: #ffc300;
  padding: 0;
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: normal;
`;

const Description = styled.p`
  padding: 0;
  color: #ffffff;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 14px;
  margin: 10px 0 20px 0;
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
`;

const Column = styled.div`
  // width: 50%;
`;

const Images = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
`;

const Image = styled.div`
  background-repeat: none;
  background-size: cover;
  height: 170px;
  width: 25%;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
  cursor: pointer;
  @media only screen and (max-width: 980px) {
    height: 100px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/GalleryContentV2.js